export type IconProps = {
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

export default function IconListChecked({ className, title }: IconProps) {
  return (
    <svg
      aria-label={title}
      className={className}
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16674 9.22125L0.580078 5.62792L1.75341 4.44792L4.16674 6.86125L10.2467 0.78125L11.4201 1.96125L4.16674 9.22125Z"
        fill="#006851"
      />
    </svg>
  );
}
